import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

export default function LandingPage() {
  const navigate = useNavigate();

  const features = [
    {highlight:'Personalised recipes', content:'from what you have avaiable'},
    {highlight:'Weekly meal planning', content:'to save time and stress'},
    {highlight:'Less food waste', content:'more flavour'},
    {highlight:'From photo to food', content:'snap a photo of ingredients or a dish to get a recipe'},
  ];

  return (
    <div className="min-h-screen bg-cover bg-center flex flex-col items-center justify-between text-slate-800" style={{ backgroundImage: 'url(/assets/use-the-oven.jpeg)' }}>
      {/* Overlay */}
      <div className="absolute inset-0 bg-white/70 backdrop-blur-sm z-0" />

      {/* Logo */}
      <div className="z-10 mt-6">
        <img src="/logo512.png" alt="Sous logo" className="h-14 w-14 shadow" />
      </div>

      {/* Hero Text */}
      <div className="z-10 text-center mt-8 px-4">
        <h1 className="text-3xl font-bold text-sage mb-2">Smarter home cooking starts here</h1>
        <p className="text-base text-slate-700">Your AI-powered kitchen assistant for easy recipes, meal planning, and zero-waste cooking.</p>
      </div>

      {/* CTA Buttons */}
      <div className="z-10 w-full px-6 mt-10 flex flex-col gap-3">
        <button
          className="bg-sage text-white py-3 rounded-xl font-semibold text-lg shadow-md hover:bg-sage/90"
          onClick={() => navigate('/login')}
        >
          Log In
        </button>
        <button
          className="border border-sage text-sage py-3 rounded-xl font-semibold text-lg hover:bg-sage/10"
          onClick={() => navigate('/register')}
        >
          Register
        </button>
      </div>

      {/* Features */}
      <div className="z-10 grid gap-4 px-6 pb-10 mt-10">
        <h2 className="text-xl font-bold text-gray-800 text-center">With Sous you can enjoy</h2>
        {features.map((feature, idx) => (
          <div key={idx} className="bg-white rounded-2xl shadow p-4 flex items-center gap-3">
            <CheckCircleIcon className="h-6 w-6 text-sage mt-1 flex-shrink-0" />
            <p className="text-slate-800 text-sm font-medium">
                <span className="font-bold">
                    {feature.highlight + " "} 
                </span>
                {feature.content}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
